module.exports = __webpack_public_path__ + "static/media/29FUNOV6.8f67fdd1.jpg";